import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from '../axiosConfig';
import {
  saveSendTripEmailRequest,
  saveSendTripEmailSuccess,
  saveSendTripEmailFailure,
} from '../../slices/trip';
import formatTripRequest from '../../../helpers/formatTripRequest';
import getVGSProxyEndpoint from '../../../helpers/getVGSProxyEndpoint';
import { buildCreditCardPayments } from '../../../helpers/buildCreditCardPayments';
import { handleCardTokenization } from '../../../helpers/tokenizeCards';
import { PaymentModes } from '../../../constants';

const queryString = require('query-string');

function* saveSendTripEmailWorker({
  payload: {
    trip,
    customerEmail,
    customerPhoneNumber,
    tripStatus,
    doIncludeCC,
    doAllowSelfBookingTripQuote,
    clientNote,
    messageToAdvisor,
    agencyPlanningFees,
    tokenizedCardMap,
    tokenizeFunc,
    isFormValid,
  },
}) {
  let tokenizedCardMapResult = tokenizedCardMap;

  try {
    const { email: loggedInUserEmail, isLoggedIn } = yield select((store) => store.user);
    const { paymentMethods } = yield select((store) => store.trip);

    // Handle tokenization if needed
    if (Object.values(paymentMethods).some((p) => p.paymentMode === PaymentModes.NEW_CREDIT_CARD)) {
      try {
        tokenizedCardMapResult = yield call(handleCardTokenization, tokenizeFunc, isFormValid);
      } catch (error) {
        yield put(saveSendTripEmailFailure(error.message));
        return;
      }
    }

    const qs = queryString.stringify(
      {
        customerEmail,
        customerPhoneNumber,
        tripStatus,
        loggedInUserEmail,
        messageToAdvisor,
      },
      { skipNull: true },
    );
    const url = `${doIncludeCC && tokenizedCardMapResult ? '' : getVGSProxyEndpoint()}/email/saveSendTrip?${qs}`;
    const filters = yield select((store) => store.tripSearch.searchObj.cruise.filters);
    const staterooms = yield select((store) => store.tripSearch.searchObj.staterooms);

    const creditCardPayments = buildCreditCardPayments({
      doIncludeCC,
      paymentMethods,
      tokenizedCardMap: [tokenizedCardMapResult],
      isLoggedIn,
    });

    const config = {
      method: 'post',
      url,
      data: JSON.stringify({
        ...formatTripRequest({
          trip,
          ...filters,
          staterooms,
        }),
        paymentMethod: creditCardPayments && creditCardPayments[0] ? creditCardPayments[0] : null,
        doAllowSelfBookingTripQuote,
        clientNote,
        agencyPlanningFees,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const { data } = yield call(axios, config);
    if (data) {
      yield put(saveSendTripEmailSuccess());
    } else {
      yield put(saveSendTripEmailFailure('Could not send email, please try it again!'));
    }
  } catch (error) {
    let errorMsg = 'Could not send email, please try it again!';
    if (error.response && error.response.data && error.response.data.title) {
      errorMsg = `${error.response.data.title} ${error.response.data.detail}`;
    } else if (error && typeof error === 'object' && error.message) {
      errorMsg = `Could not send email, please try it again! ${error.name}: ${error.message} (${error.code}).`;
    }
    yield put(saveSendTripEmailFailure(errorMsg));
  }
}

function* saveSendTripEmailWatcher() {
  yield takeLatest(saveSendTripEmailRequest.toString(), saveSendTripEmailWorker);
}

export default saveSendTripEmailWatcher;
